// 本番環境
export const API_PATH = "https://minmado.jp/rs/tl";
export const EKYC_BASE_URL = 'https://minmado.jp/ekyc';
export const TITLE = "みんなの窓口";
export const SOCKET_PATH = 'https://minmado.jp';
export const SOCKET_SUB_PATH = '';
export const KC_URL = 'https://minmado.jp/auth/';
export const KC_REALM = 'govtok';
export const KC_CLIENT_ID = 'gatekeeper';
export const HOMEPAGE = '/reserve';
